import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const TERRITORY_IMG = "/territory-iblei-4k.webp";

export default function TerritoryParallax() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-6%", "6%"]);

  return (
    <section
      ref={ref}
      data-testid="territory-parallax-section"
      className="relative bg-[#0A0A0A]"
    >
      {/* Mobile: immagine intera, nessun ritaglio */}
      <div className="sm:hidden">
        <img
          src={TERRITORY_IMG}
          alt="Altopiano Ibleo al tramonto — muretti a secco, vigne e borgo"
          className="w-full h-auto block"
          loading="lazy"
          data-testid="territory-image-mobile"
        />
        <div className="px-6 py-8">
          <div className="flex items-center gap-5 mb-3">
            <div className="h-px w-10" style={{ background: "#C4A671" }} />
            <span className="overline text-[10px]" style={{ color: "#C4A671" }}>
              Il Territorio
            </span>
          </div>
          <p
            className="font-serif-display italic leading-[1.1] text-[#FDFBF7]"
            style={{ fontSize: "clamp(1.5rem, 6vw, 2rem)" }}
          >
            L&apos;Altopiano Ibleo, dove tutto ha origine.
          </p>
        </div>
      </div>

      {/* Desktop: parallasse immersivo full-screen */}
      <div className="hidden sm:block relative h-[85vh] lg:h-screen overflow-hidden">
        <motion.img
          src={TERRITORY_IMG}
          alt="Altopiano Ibleo al tramonto — muretti a secco, vigne e borgo"
          style={{ y, scale: 1.15 }}
          className="absolute inset-0 w-full h-full object-cover will-change-transform"
          loading="lazy"
          data-testid="territory-parallax-image"
        />
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(to bottom, rgba(10,10,10,0.35) 0%, rgba(10,10,10,0) 30%, rgba(10,10,10,0) 65%, rgba(10,10,10,0.45) 100%)",
          }}
          aria-hidden
        />
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1.1, ease: "easeOut" }}
          className="absolute bottom-14 left-12 lg:left-20"
        >
          <div className="flex items-center gap-5 mb-4">
            <div className="h-px w-12" style={{ background: "#C4A671" }} />
            <span className="overline text-[10px]" style={{ color: "#C4A671" }}>
              Il Territorio
            </span>
          </div>
          <p
            className="font-serif-display italic leading-[1.05] text-[#FDFBF7]"
            style={{
              fontSize: "clamp(1.6rem, 3.4vw, 2.8rem)",
              textShadow: "0 2px 24px rgba(0,0,0,0.45)",
            }}
          >
            L&apos;Altopiano Ibleo,
            <br />
            dove tutto ha origine.
          </p>
        </motion.div>
      </div>
    </section>
  );
}
